import React, { PropsWithChildren, useContext } from 'react'

import { Features } from 'generated/featureDefinitions'
import { PlanSettingsRootPageQuery } from 'generated/resources/graphql'

interface PlanSettingsContextProviderProps {
  data: PlanSettingsRootPageQuery
}

interface PlanSettingsContextType extends PlanSettingsContextProviderProps {
  featureAvailabilities: {
    expensesPerUserPricing: boolean
  }
}

const PlanSettingsContext = React.createContext<PlanSettingsContextType | null>(null)

export const PlanSettingsContextProvider: React.FC<
  PropsWithChildren<PlanSettingsContextProviderProps>
> = ({ data, children }) => {
  const expensesPerUserPricingAvailable =
    data.companies.featureAvailabilitiesConnection.nodes.find(
      (f) => f.id === Features.expenses_per_user_pricing_create_expenses
    )?.available ?? false

  return (
    <PlanSettingsContext.Provider
      value={{
        data,
        featureAvailabilities: {
          expensesPerUserPricing: expensesPerUserPricingAvailable,
        },
      }}
    >
      {children}
    </PlanSettingsContext.Provider>
  )
}

export const usePlanSettingsContext = () => {
  const context = useContext(PlanSettingsContext)

  if (!context) {
    throw new Error('usePlanSettingsContext used without a provider')
  }

  return context
}
